import { RG_TYPE } from '../../types/rg-type.js';

/** @deprecated use DTOs instead
 * serialise by removing circular dependencies */
function rgSerialise(obj) {
    obj.parent = undefined;
    // @todo this removes the anatomy of the building and should be replaced with a better serialisation strategy, as per https://app.clickup.com/t/2uaqwba
    if (obj.type === RG_TYPE.Building) {
        obj.data.anatomy = undefined;
    }
    for (let i = 0; i < obj.children.length; i++) {
        obj.children[i] = rgSerialise(obj.children[i]);
    }
    return obj;
}

export { rgSerialise };
//# sourceMappingURL=rg-serialise.js.map
